import React, { useEffect, useState } from "react";
import { Button, Col } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import { setGlobalFilter } from "../../Redux/actions/globalFilterActions";

const mapDispatchToProps = (dispatch) => ({
  setGlobalFilter: (user) => dispatch(setGlobalFilter(user)),
});

function Filters({ setGlobalFilter }) {
  const [show, setShow] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  // county  option states
  const [countyOption, setCountyOption] = useState([]);
  const [selectedCoOption, setSelectedCoOption] = useState(null);
  const [countyId, setCountyId] = useState([]);
  // sub county option states
  const [subCountyOption, setsubCountyOption] = useState([]);
  const [selectedsubOption, setSelectedsubOption] = useState(null);
  const [subcountyId, setsubCountyId] = useState([]);
  // cases options states
  const [caseCatOptions, setcaseCatOptions] = useState([]);
  const [selectedCatOption, setSelectedCatOption] = useState(null);
  const [globalDateFilter, setGlobalDateFilter] = useState({
    label: "Yearly",
    value: "YEARLY",
  });
  const [quarterSelect, setQuarterSelect] = useState({});

  // const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getCountyOptionData();
    getCategoryCaseData();
  }, []);

  useEffect(() => {
    if (selectedCoOption !== null) {
      getSubCountyOptionData();
    }
  }, [selectedCoOption]);

  const getCountyOptionData = async () => {
    let data = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
    };
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getCountyOptions`,
        data
      );
      let response = res.data.data;
      let countyOptinArr = [];
      Object.keys(response.optionMap ? response.optionMap : {}).forEach(
        (value) => {
          countyOptinArr = [
            ...countyOptinArr,
            {
              value: value,
              label: response.optionMap[value],
            },
          ];
        }
      );

      setCountyOption(countyOptinArr);
      setCountyId(response.questionIds);
    } catch (error) {
      console.log(error);
    }
  };

  const getSubCountyOptionData = async () => {
    let data = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      questionIds: countyId,
      selectedOptions: [selectedCoOption.value],
    };
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getSubCountyOptions`,
        data
      );
      let response = res.data.data;
      let subCountyArr = [];
      Object.keys(response.optionMap).forEach((value) => {
        subCountyArr = [
          ...subCountyArr,
          {
            value: value,
            label: response.optionMap[value],
          },
        ];
      });
      setsubCountyOption(subCountyArr);
      setsubCountyId(response.subQuestionIds);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryCaseData = async () => {
    let data = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      languageId: 1,
    };
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/getInvolved/getServiceByCommunityId`,
        data
      );
      let response = res.data.data;
      let casesArr = [];
      response.forEach((value) => {
        casesArr = [
          ...casesArr,
          {
            value: value.id,
            label: value.name,
          },
        ];
      });
      setcaseCatOptions(casesArr);
    } catch (error) {
      console.log(error);
    }
  };

  const applyFilter = () => {
    // handleClose();
    let requestObj = {};
    const periodType = globalDateFilter.value;
    const quarterType = quarterSelect.value;

    if (selectedCoOption != null && selectedsubOption == null) {
      requestObj.questionIds = countyId;
      requestObj.selectedOption = [selectedCoOption.value];
    }

    if (selectedsubOption != null) {
      requestObj.subQuestionIds = subcountyId;
      requestObj.selectedOption = [selectedsubOption.value];
    }

    if (selectedCatOption != null) {
      requestObj.serviceIdFilter = selectedCatOption.value;
    }

    if (fromDate != "" || toDate != "") {
      requestObj = {
        from: fromDate,
        to: toDate,
        periodType,
        quarter: quarterType ? quarterType : "",
      };
    }
    setGlobalFilter({ ...requestObj });
  };

  const clearFilter = () => {
    // handleClose();
    setFromDate("");
    setToDate("");
    setSelectedCoOption(null);
    setSelectedsubOption(null);
    setSelectedCatOption(null);
    setGlobalFilter({});
    setGlobalDateFilter({
      label: "Yearly",
      value: "YEARLY",
    });
    setQuarterSelect({});
  };

  const handlePeriodType = (selectedPeriod) => {
    setQuarterSelect({});
    setFromDate("");
    setToDate("");
    setGlobalDateFilter(selectedPeriod);
  };

  const handleFormYearChange = (selectedYear) => {
    const formYear = moment(selectedYear.toString()).format("YYYY");
    setFromDate(formYear);
    setToDate(formYear);
  };

  const handleToYearChange = (selectedYear) => {
    const toYear = moment(selectedYear.toString()).format("YYYY");
    setToDate(toYear);
  };

  const handleFromMonthChange = (selectedMonth) => {
    const fromMonthWise = moment(selectedMonth.toString()).format("YYYY-MM");
    setFromDate(fromMonthWise);
    setToDate(fromMonthWise);
  };

  const handleToMonthChange = (selectedMonth) => {
    const toMonthWise = moment(selectedMonth.toString()).format("YYYY-MM");
    setToDate(toMonthWise);
  };

  const handleQuarterWiseYear = (selectedYear) => {
    const selectedQuarter = moment(selectedYear.toString()).format("YYYY");
    setFromDate(selectedQuarter);
  };

  const handleQuarterSelect = (selectedQuarter) => {
    setQuarterSelect(selectedQuarter);
  };

  const validFromDate = (current) => {
    return current.isSameOrBefore(moment(new Date()));
  };

  return (
    <div>
      <Col lg={12} className="sidepanelWrapper">
        <div id="mySidepanel" className="sidepanel">
          <div className="sidebar-inner">
            <Row className="sidebarfilter" style={{ alignItems: "flex-end" }}>
              <Col lg={2}>
                <div className="mt-4">
                  <label className="mb-1">Period Type</label>
                  <Select
                    isMulti={false}
                    name="dateFilter"
                    value={globalDateFilter}
                    onChange={handlePeriodType}
                    options={[
                      { label: "Yearly", value: "YEARLY" },
                      { label: "Quarterly ", value: "QUARTERLY" },
                      { label: "Monthly", value: "MONTHLY" },
                    ]}
                  />
                </div>
              </Col>
              {globalDateFilter.value === "YEARLY" && (
                <Col lg={4} className="date-filter">
                  <div className="mt-4">
                    <label>From</label>
                    <Datetime
                      value={fromDate}
                      key={fromDate}
                      dateFormat="YYYY"
                      timeFormat={false}
                      onChange={handleFormYearChange}
                      className="date-input mgt-5"
                      closeOnSelect={true}
                      initialViewMode="years"
                      isValidDate={validFromDate}
                    />
                  </div>
                  <div className="mt-4">
                    <label>To</label>
                    <Datetime
                      value={toDate || fromDate}
                      dateFormat="YYYY"
                      key={toDate}
                      timeFormat={false}
                      onChange={handleToYearChange}
                      className="date-input mgt-5"
                      closeOnSelect={true}
                      initialViewMode="years"
                      isValidDate={validFromDate}
                    />
                  </div>
                </Col>
              )}
              {globalDateFilter.value == "QUARTERLY" && (
                <Col lg={4} className="date-filter">
                  <Row className="mt-4 w-100">
                    <Col lg={6}>
                      <label className="mgt-5">From</label>
                      <Datetime
                        value={fromDate}
                        style={{ color: "#000" }}
                        dateFormat="YYYY"
                        timeFormat={false}
                        onChange={handleQuarterWiseYear}
                        className="date-input mgt-5"
                        closeOnSelect={true}
                        initialViewMode="years"
                        isValidDate={validFromDate}
                      />
                    </Col>
                    <Col lg={6}>
                      <label className="mgt-5">Select Quarter</label>
                      <Select
                        isMulti={false}
                        name="quarterSelect"
                        value={quarterSelect}
                        className="mgt-5"
                        onChange={handleQuarterSelect}
                        options={[
                          { label: "Quarter 1(Jan-Mar)", value: "1" },
                          { label: "Quarter 2(Apr-Jun) ", value: "2" },
                          { label: "Quarter 3(Jul-Sep)", value: "3" },
                          { label: "Quarter 4(Oct-Dec)", value: "4" },
                        ]}
                      />
                    </Col>
                  </Row>
                </Col>
              )}
              {globalDateFilter.value === "MONTHLY" && (
                <Col lg={4} className="date-filter">
                  <div className="mt-4">
                    <label>From</label>
                    <Datetime
                      value={fromDate}
                      style={{ color: "#000" }}
                      dateFormat="YYYY-MM"
                      timeFormat={false}
                      onChange={handleFromMonthChange}
                      className="date-input mgt-5"
                      closeOnSelect={true}
                      initialViewMode="years"
                      isValidDate={validFromDate}
                    />
                  </div>
                  <div className="mt-4">
                    <label>To</label>
                    <Datetime
                      value={toDate || fromDate}
                      style={{ color: "#000" }}
                      dateFormat="YYYY-MM"
                      timeFormat={false}
                      onChange={handleToMonthChange}
                      className="date-input mgt-5"
                      closeOnSelect={true}
                      initialViewMode="years"
                      isValidDate={validFromDate}
                    />
                  </div>
                </Col>
              )}
              <Col lg={2}>
                <div className="mt-4">
                  <label>County</label>
                  <Select
                    key={selectedCoOption}
                    className="mgt-5"
                    isClearable
                    defaultValue={selectedCoOption}
                    onChange={(e) => setSelectedCoOption(e)}
                    options={countyOption}
                  />
                </div>
              </Col>
              <Col lg={2}>
                <div className="mt-4">
                  <label>Sub-County</label>
                  <Select
                    key={selectedsubOption}
                    isClearable
                    className="mgt-5"
                    defaultValue={selectedsubOption}
                    onChange={(e) => setSelectedsubOption(e)}
                    options={subCountyOption}
                  />
                </div>
              </Col>
              <Col lg={2}>
                <div className="mt-4">
                  {" "}
                  <label>Category of Cases</label>
                </div>

                <Select
                  key={selectedCatOption}
                  className="mgt-5"
                  value={selectedCatOption}
                  onChange={(e) => setSelectedCatOption(e)}
                  options={caseCatOptions}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="mt-4 filterbtns">
                  <Button className="apply-btn" onClick={() => applyFilter()}>
                    Apply
                  </Button>
                  <Button
                    className="apply-btn ml-10"
                    onClick={() => clearFilter()}
                  >
                    Clear
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </div>
  );
}

export default connect(null, mapDispatchToProps)(React.memo(Filters));
